import * as Sentry from '@sentry/react'
import { commonConfig } from '@/stores'
import { reaction } from 'mobx'

let isEnabled = false

export function initSentry() {
  if (!__DEV__) {
    isEnabled = true
    Sentry.init({
      dsn: 'https://4f9cc225796016c6cec02c57182782ba@o468184.ingest.sentry.io/4506234156351488',
      environment: DEPLOY_ENV || 'test',
      ignoreErrors: [
        'ResizeObserver',
        'AbortError: The play() request',
        'Request failed with status code 403',
        'Request failed with status code 401'
      ]
    })
  }
}

export function captureException(error: any, context: Record<string, any>) {
  if (!isEnabled) return

  Sentry.withScope((scope) => {
    for (const key in context) {
      scope.setTag(key, context[key])
    }
    Sentry.captureException(error)
  })
}

initSentry()

reaction(
  () => commonConfig.isLoading,
  (isLoading) => {
    if (!isLoading) {
      Sentry.setUser({
        email: commonConfig.email
      })
    }
  }
)
